<template>
    <section id="section">
        <div class="header im">
            <div class="search-box" @click.stop="keywords_show = true">
                <input class="input" type="text" @keydown.enter="search" v-model="keyword">
                <input type="text" name="hidden" class="input-hidden">
                <span class="button" @click="search">搜索</span>

                <div class="search-history" v-show="keywords_show && keywords.length">
                    <div class="history-title-box">
                        <div class="history-title">历史搜索</div>
                    </div>

                    <div v-for="v in keywords.slice(0, 5)" class="history-item" @click.stop="$router.push(`/search?keyword=${v}`)">
                        <div class="history-text ellipsis">{{v}}</div>
                        <i class="icon-close" @click.stop="clear(v)"></i>
                    </div>

                </div>
            </div>
        </div>

        <div class="nav cb">
            <div :class="`li first${!query.type ? ' active' : ''}`" @click="search">综合</div>
            <div :class="`li second${query.type === 'video' ? ' active' : ''}`" @click="allVideo">视频</div>
            <div :class="`li third${query.type === 'dancer' ? ' active' : ''}`" @click="searchDancer">舞者</div>
            <div :class="`line${lineClass}`"></div>
        </div>

        <div class="empty" v-show="is_empty">抱歉，没有找到 <span class="keyword">{{lastKeyword}}</span> 的相关内容</div>

        <!--综合舞者列表-->
        <div v-if="dancers.length && !query.type">
            <div class="dancer-title-box cb">
                <span class="dancer-title fl">热门舞者</span>
                <span v-show="dancers.length === 8" class="show-all fr" @click="searchDancer">查看全部</span>
            </div>

            <div class="dancer-list cb">

                <a v-for="v in dancers" :key="v.id" :href="`/dancers/${v.id}`" class="dancer-link" target="_blank">
                    <img class="dancer-img" :src="v.thumb">
                    <div v-html="v.name.replace(RegExp(lastKeyword, 'i'), e => `<span class='keyword'>${e}</span>`)" class="dancer-name ellipsis"></div>
                    <div class="dancer-hover im">
                        <div class="dancer-mask"></div>
                        <div class="dancer-follow">
                            <span>{{v.fans}}人</span>
                            <br>
                            已关注
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <!--视频列表-->
        <div v-if="videos.length && query.type !== 'dancer'">
            <div v-show="!query.type" class="dancer-title-box cb">
                <span class="dancer-title fl">热门视频</span>
                <span v-show="videos.length === 15" @click="allVideo" class="show-all fr">查看全部</span>
            </div>

            <div v-show="query.type === 'video'" class="filter-box">
                <div class="filter">
                    <span class="filter-title">分类：</span>
                    <div class="filter-option">
                        <span :class="`option${!query.sort ? ' option-active' : ''}`" @click="sortVideo()">全部</span>
                        <span v-for="v in sorts" :key="v.id" @click="sortVideo(v.id)" :class="`option${+query.sort === v.id ? ' option-active' : ''}`">{{v.name}}</span>
                    </div>
                </div>
                <div class="filter">
                    <span class="filter-title">排序：</span>
                    <div class="filter-option">
                        <span :class="`option${!query.order ? ' option-active' : ''}`" @click="orderVideo()">最热视频</span>
                        <span :class="`option${query.order === 'new' ? ' option-active' : ''}`" @click="orderVideo('new')">最新视频</span>
                        <span :class="`option${query.order === 'collect' ? ' option-active' : ''}`" @click="orderVideo('collect')">最多收藏</span>
                    </div>
                </div>
            </div>

            <ul class="video-lists-box">
                <li class="video-lists" v-for="v in videos" :key="v.id">
                    <a :href="`/videos/${v.id}`" :title="v.title" class="video-lists-link" target="_blank">
                        <div class="pr">
                            <i class="icon-play"></i>
                            <img class="video-thumb" v-lazy="v.thumb">
                            <div class="video-thumb video-mask"></div>
                        </div>
                        <div class="video-meta-box">
                            <div class="video-title-box">
                                <h3 class="video-title ellipsis" v-html="v.title.replace(RegExp(lastKeyword, 'i'), e => `<span class='keyword'>${e}</span>`)"></h3>
                                <span class="video-cate ellipsis" :title="`舞蹈风格: ${v.sort}`">{{v.sort}}</span>
                            </div>
                            <p class="video-count-box">
                            <span class="video-plays" :title="`播放量: ${v.views}`">
                                <i class="icon-video"></i> {{$view(v.views)}}
                            </span>
                                <span class="video-comments" :title="`上传时间: ${v.addtime}`">
                                <i class="icon-clock"></i> {{$time(v.addtime)}}
                            </span>
                            </p>
                        </div>
                    </a>
                </li>
            </ul>
        </div>

        <!--舞者列表-->
        <ul v-if="dancerLists.length && query.type === 'dancer'">
            <li v-for="(v, k) in dancerLists" :key="v.id" class="dancer-item cb">
                <a :href="`dancers/${v.id}`" class="dancers-thumb" target="_blank">
                    <img class="dancers-img" :src="v.thumb" :alt="v.thumb">
                </a>
                <div class="dancers-name">
                    <a :href="`dancers/${v.id}`" v-html="v.name.replace(RegExp(lastKeyword, 'i'), e => `<span class='keyword'>${e}</span>`)" class="dancers-name-text"></a>
                    <span v-show="!v.is_follow" class="dancers-button bg" @click="follow(k, v.id)">关注</span>
                    <span v-show="v.is_follow" class="dancers-button unfollow" @click="unfollow(k, v.id)">取消关注</span>
                </div>
                <div class="dancers-info">
                    <span class="dancers-info-text">{{v.region}} | {{v.sorts}}</span>
                    <span class="dancers-info-text">视频: {{v.count}}</span>
                    <span>粉丝: {{v.fans}}</span>
                </div>
                <div class="cb">
                    <div class="dancers-video-item" v-for="vv in v.videos" :key="vv.id">
                        <a :href="`/videos/${vv.id}`" class="dancers-video-thumb" target="_blank">
                            <i class="icon-play"></i>
                            <img class="dancers-video-img" v-lazy="vv.thumb">
                            <div class="video-thumb video-mask"></div>
                        </a>
                        <div class="dancers-video-info">
                            <a :href="`/videos/${vv.id}`" class="dancers-video-link" target="_blank">{{vv.title}}</a>
                            <span class="dancers-video-time">{{$time(vv.addtime)}}</span>
                        </div>
                    </div>
                </div>
            </li>
        </ul>

        <el-pagination v-if="counts > 40" background layout="total, prev, pager, next" :current-page="page"  @current-change="currentChange" :page-size="pageSize" :total="counts" class="pagenavi"></el-pagination>

    </section>
</template>

<script>
    export default {
        data: () => ({
            dancers: [],
            videos: [],
            dancerLists: [],
            sorts: [],
            keyword: '',
            is_empty: false,
            lastKeyword: '',
            page: 1,
            counts: 0,
            is_follow: [],
            is_lock: false,
            pageSize: 0,
            keywords_show: false,
        }),
        computed: {
            lineClass() {
                let {type} = this.query, className;
                if (!type) {
                    className = '';
                } else if (type === 'video') {
                    className = ' video-active';
                } else if (type === 'dancer') {
                    className = ' dancer-active';
                }
                return className;
            },
            query() {
                return this.$route.query;
            },
            state() {
                return this.$store.state;
            },
            keywords() {
                return this.state.search;
            },
            uid () {
                return this.state.user.id;
            },
            sign() {
                return this.state.sign;
            }
        },
        watch: {
            uid() {
                let {api, query} = this, {keyword, page} = query;
                if (query.type === 'dancer') {
                    api.get('search', {keyword, type: 'dancer', page: page || 1}).then(e => {
                        this.dancerLists = e;
                        this.page = +page;
                        this.pageSize = 10;
                    });
                    api.get('search/count', {keyword, type: 'dancer'}).then(e => {
                        this.counts = e;
                        if (!e) this.is_empty = true;
                    })
                }
            }
        },
        methods: {
            load(to, next) {
                let {api, keywords} = this, {keyword, type, sort, page, order} = to.query;
                this.keyword = this.lastKeyword = keyword;
                this.counts = 0;
                this.pageSize = 0;
                this.is_empty = this.keywords_show = false;

                if (keyword) {

                    sort = sort || '';
                    type = type || '';
                    api.get('search', {keyword, type, sort, page: page || 1, order: order || ''}).then(e => {
                        if (!type) {
                            this.dancers = e.dancers;
                            this.videos = e.videos;
                            if (!e.dancers.length && !e.videos.length) this.is_empty = true;

                        } else if (type === 'video') {
                            this.videos = e;
                            this.page = +page;
                            this.pageSize = 40;
                            if (!e.length) this.is_empty = true;

                        } else if (type === 'dancer') {
                            this.dancerLists = e;
                            this.page = +page;
                            this.pageSize = 10;
                            if (!e.length) this.is_empty = true;
                        }

                    }, this.err);

                    if (type) {
                        api.get('search/count', {keyword, type, sort}).then(e => this.counts = e, this.err);
                    }

                    keywords.unshift(keyword);
                    let arr = Array.from(new Set(keywords));
                    this.state.search = arr;
                    window.localStorage.search = JSON.stringify(arr);

                } else {
                    this.videos = this.dancers = this.dancerLists = [];
                }

                next && next();
            },
            search() {
                this.$router.push(`/search?keyword=${this.keyword}`)
            },
            allVideo() {
                this.$router.push(`/search?keyword=${this.lastKeyword}&type=video`)
            },
            sortVideo(sort) {
                this.$router.push(`/search?keyword=${this.lastKeyword}&type=video&sort=${sort || ''}&order=${this.query.order || ''}`)
            },
            orderVideo(order) {
                this.$router.push(`/search?keyword=${this.lastKeyword}&type=video&sort=${this.query.sort || ''}&order=${order || ''}`)
            },
            currentChange(page) {// 页码改变
                let {keyword, type, sort, order} = this.query;
                this.$router.push(`/search?keyword=${keyword}&type=${type || ''}&sort=${sort || ''}&order=${order || ''}&page=${page}`);
            },
            searchDancer() {
                this.$router.push(`/search?keyword=${this.lastKeyword}&type=dancer`)
            },
            follow(k, id) {
                const {setFollow} = this;

                if (this.is_lock) return;
                if (!this.uid) return this.sign.sign_box_show = true;
                this.is_lock = true;
                setFollow(k, true);

                this.api.post(`dancers/${id}/follow`).then(() => this.is_lock = false, () => setFollow(k, false));
            },
            unfollow(k, id) {
                const {setFollow} = this;

                if (this.is_lock) return;
                this.is_lock = true;
                setFollow(k, false);

                this.api.del(`dancers/${id}/follow`).then(() => this.is_lock = false, () => setFollow(k, true));
            },
            setFollow(k, follow) {
                if (follow) {
                    this.dancerLists[k].is_follow = true;
                    this.dancerLists[k].fans++;
                } else {
                    this.dancerLists[k].is_follow = false;
                    this.dancerLists[k].fans--;
                }
            },
            clear(keyword) {
                let set = new Set(this.keywords), arr;
                set.delete(keyword);
                arr = Array.from(set);
                this.$store.state.search = arr;
                window.localStorage.search = JSON.stringify(arr);
            },
            hideKeyword() {
                this.keywords_show = false;
            }
        },
        beforeMount() {
            this.api.get('home/sorts').then(e => this.sorts = e, this.err);
            this.load(this.$route);
        },
        beforeRouteUpdate(to, from, next) {// 路由改变前，组件就已经渲染完了
            this.load(to, next);
        },
        mounted() {
            document.body.addEventListener('click', this.hideKeyword);
        },
        beforeDestroy() {
            document.body.removeEventListener("click", this.hideKeyword);
        }
    }
</script>

<style scoped>
    @import "../../../static/css/common/lists.css";
    @import "../../../static/css/views/home/lists.css";
    @import '../../../static/css/common/search.css';
    @import "../../../static/css/views/search/index.css";
</style>


// WEBPACK FOOTER //
// src/views/search/index.vue